import FrequencyTrendLimitLogFactory from "../../factories/FrequencyTrendLimitLogFactory";
import ObjectHandleService from "@/services/common/ObjectHandleService";
import ValidateNumber from "@/services/common/numbers/validations/ValidateNumber";

const getters = {

	/**
	* Retorna a configuração das colunas da tabela.
 	* @returns Um array de objetos que configuram as colunas da tabela.
 	*/
	headers()
	{
		return FrequencyTrendLimitLogFactory.HeaderTableView();
	},

	/**
 	* Retorna uma visualização de emails modificados baseada no estado atual selecionado.
 	*
 	* @param {Object} state - O estado Vuex atual.
 	* @returns  Um objeto contendo os emails modificados e suas informações associadas.
 	*/
	modifiedEmails(state)
	{
		const modifiedEmails = FrequencyTrendLimitLogFactory.ModifiedEmailsViewEmpty();

		const item = state.itemOnEmailClick;
		if (ObjectHandleService.IsObject(item) && ObjectHandleService.IsEmpty(item)) return modifiedEmails;

		const { tripEmailRecipients } = item;
		const { alarmEmailRecipients } = item;

		const isTripEmailsValid = Array.isArray(tripEmailRecipients) && tripEmailRecipients.length > 0;
		const isAlarmEmailValid = Array.isArray(alarmEmailRecipients) && alarmEmailRecipients.length > 0;
		const bothAreValid = isTripEmailsValid && isAlarmEmailValid;

		if (bothAreValid)
		{
			modifiedEmails.hasEmails = true;
			// Funciona apenas para array de valores, não funciona com array de objetos.
			const areTheyEquals = JSON.stringify(tripEmailRecipients) === JSON.stringify(alarmEmailRecipients);
			modifiedEmails.areTheyEquals = areTheyEquals;
			modifiedEmails.alarmEmails = alarmEmailRecipients;
			modifiedEmails.tripEmails = tripEmailRecipients;

			return modifiedEmails;
		}
		else if (isAlarmEmailValid)
		{
			modifiedEmails.hasEmails = true;
			modifiedEmails.alarmEmails = alarmEmailRecipients;
			modifiedEmails.tripEmails = [];

			return modifiedEmails;
		}
		else if (isTripEmailsValid)
		{
			modifiedEmails.hasEmails = true;
			modifiedEmails.trip = alarmEmailRecipients;
			modifiedEmails.alarmEmails = [];

			return modifiedEmails;
		}
		return modifiedEmails;
	},

	/**
	* Verifica se o tipo de modificação de limite é válido.
	*
	* @returns {boolean} - Retorna `true` se o tipo de modificação de limite for um número válido,
	* caso contrário, `false`.
	*/
	isLimitModificationTypeValid(state)
	{
		const value = state.itemOnExpandedPanel[0].limitsModificationType;
		return ValidateNumber.IsValidNumber(value);
	},

	/**
	* Verifica se o tipo de modificação de notificação é válido.
	*
	* @returns {boolean} - Retorna `true` se o tipo de modificação de notificação for um número válido,
	* caso contrário, `false`.
	*/
	isNotificationModificationTypeValid(state)
	{
		const value = state.itemOnExpandedPanel[0].notificationsModificationType;
		return ValidateNumber.IsValidNumber(value);
	},

	/**
	* Verifica se há um intervalo de horas anterior para o limite.
	*
	* @returns {boolean} - Retorna `true` se o intervalo de horas anterior for um número válido,
	* caso contrário, `false`.
	*/
	hasPreviousIntervalHours(state)
	{
		const value = state.itemOnExpandedPanel[0].previousLimitIntervalHours;
		return ValidateNumber.IsValidNumber(value);
	},

	/**
	* Verifica se há um número máximo de notificações para o limite anterior.
	*
	* @returns {boolean} - Retorna `true` se o número máximo de notificações for um número válido,
	* caso contrário, `false`.
	*/
	hasPreviousLimitMaxNotifications(state)
	{
		const value = state.itemOnExpandedPanel[0].previousLimitMaxNotifications;
		return ValidateNumber.IsValidNumber(value);
	},

	/**
	 * Verifica se há um valor de atenção anterior.
	 * @returns Verdadeiro se houver valor.
	 */
	hasPreviousAlarm(state)
	{
		return state.itemOnExpandedPanel[0].previousAlarm !== null;
	},

	/**
	 * Verifica se há um valor de alerta anterior.
	 * @returns Verdadeiro se houver valor.
	 */
	hasPreviousTrip(state)
	{
		return state.itemOnExpandedPanel[0].previousTrip !== null;
	},

	/**
	 * Verifica se há um valor de debounce anterior.
	 * @returns Verdadeiro se houver valor.
	 */
	hasPreviousDebounce(state)
	{
		return state.itemOnExpandedPanel[0].previousDebounceTriggerTrend !== null;
	}
};

export default { getters };